import { Sailing } from "./sailing";
import { Sanitizer } from "./sanitizer";
import { Savings } from "./savings";
import { School } from "./school";
import { Science } from "./science";
import { SelfImprovement } from "./self_improvement";
import { SentimentsatisfiedAlt } from "./sentiment_satisfied_alt";
import { Shield } from "./shield";
import { Snowmobile } from "./snowmobile";
import { StarRate } from "./star_rate";
import { SupportAgent } from "./support_agent";
import { Support } from "./support";

const iconsList = [
  { label: "Sailing", code: <Sailing /> },
  { label: "Sanitizer", code: <Sanitizer /> },
  { label: "Savings", code: <Savings /> },
  { label: "School", code: <School /> },
  { label: "Science", code: <Science /> },
  { label: "SelfImprovement", code: <SelfImprovement /> },
  { label: "SentimentsatisfiedAlt", code: <SentimentsatisfiedAlt /> },
  { label: "Shield", code: <Shield /> },
  { label: "Snowmobile", code: <Snowmobile /> },
  { label: "StarRate", code: <StarRate /> },
  { label: "SupportAgent", code: <SupportAgent /> },
  { label: "Support", code: <Support /> },
];

export {
  iconsList,
  Sailing,
  Sanitizer,
  Savings,
  School,
  Science,
  SelfImprovement,
  SentimentsatisfiedAlt,
  Shield,
  Snowmobile,
  StarRate,
  SupportAgent,
  Support,
};
